module.exports = __webpack_public_path__ + "img/win.820d144d.png";